var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sent-status"},[_c('i',{staticClass:"feather-check-circle",attrs:{"aria-hidden":"true"}})])
}]

export { render, staticRenderFns }